import React from "react"
import { Layout } from "antd"
import styles from "./index.module.css"
import { Outlet, useMatch } from "react-router-dom"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
import { BreadCrumbs } from "ui/BreadCrumbs"

export const ProStaffLayout = () => {
  const { t } = useTranslation()
  const pageTitle = t("pro.sidebar.account.staff")
  const matchStaffDetail = useMatch("/pro/home/staff/:id")

  const subPages = matchStaffDetail ? ["Staff member details"] : []

  return (
    <Layout className={classNames(styles.layout)}>
      <BreadCrumbs iconName="staffManagement" category={pageTitle} subPages={subPages} />
      <Outlet />
    </Layout>
  )
}
